export default {
  ONE_TIME: "One Time",
  RECURRING: "Recurring",
};
